import { render } from "./StudentSignUpProcess.vue?vue&type=template&id=dd82f79e"
import script from "./StudentSignUpProcess.vue?vue&type=script&lang=js"
export * from "./StudentSignUpProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__